import { CartUpdateEvent } from '@theme/events';

function initProductCustom(scope = document) {
  const atcWrappers = scope.matches?.(".atc-icon-wrapper")
    ? [scope]
    : scope.querySelectorAll(".atc-icon-wrapper");

  atcWrappers.forEach((wrapper) => {
    if (wrapper.dataset.productCustomInit === "true") return;

    wrapper.dataset.productCustomInit = "true";

    const openBtn = wrapper.querySelector(".atc-plus-icon");
    const popup = wrapper.querySelector(".variant-popup");
    const closeBtn = wrapper.querySelector(".close-popup-size");
    const popupInner = wrapper.querySelector(".variant-popup-inner");
    const variantButtons = wrapper.querySelectorAll(".custom-size-row");
    const completeLookBtn = wrapper.querySelector(".cmpt-lk");

    if (!openBtn) return;

    // ADD TO CART
    async function addToCart(variantId, qty = 1, isProperties) {
      try {
        setButtonState(openBtn, "loading");

        document.body.classList.remove("atc-opened");
        const itemPayload = {
              id: Number(variantId),
              quantity: qty,
            };
        if (isProperties === "true") {
          itemPayload.properties = {
          _free_gift: "Yes",
          };
        }
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [itemPayload],
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to add cart");
        }

        const addedData = await response.json();
        if (typeof triggerKlaviyoAddedToCart === "function") {
          triggerKlaviyoAddedToCart(addedData);
        }

        addedState(openBtn);;
        document.body.classList.remove("cstm-pro-overlay");
        document.dispatchEvent(
          new CartUpdateEvent({
            source: "variant-popup-inner",
          })
        );
      } catch (error) {
        console.error("Cart Error:", error);
      }
    }

    // BUTTON STATES
    function setButtonState(button, state) {
      if (!button) return;

      button.classList.remove(
        "state-default",
        "state-loading",
        "state-success"
      );

      button.classList.add(`state-${state}`);
    }

    function addedState(button) {
      setButtonState(button, "success");

      setTimeout(() => {
        setButtonState(button, "default");
      }, 2000);
    }

    // GET SELECTED OPTIONS
    function getSelectedOptions() {
      const selectedOptions = [];

      wrapper.querySelectorAll(".custom-size-row.active").forEach((btn) => {
        const position = Number(btn.dataset.optionPosition);
        const value = btn.dataset.optionValue;

        if (position && value) {
          selectedOptions[position - 1] = value;
        }
      });

      return selectedOptions;
    }

    // GET MATCHED VARIANT
    function getVariantDataFromJson(jsonString, selectedOptions) {
      if (!jsonString || !selectedOptions.length) return null;

      try {
        const variants = JSON.parse(jsonString);

        const matchedVariant = variants.find((variant) =>
          selectedOptions.every((optionValue, index) => {
            if (!optionValue) return true;

            return (
              String(variant[`option${index + 1}`])
                .trim()
                .toLowerCase() === optionValue.trim().toLowerCase()
            );
          })
        );

        if (!matchedVariant) return null;

        // ELEMENTS
        const changeTitle = completeLookBtn?.querySelector(
          ".add-to-cart-text__content"
        );

        const stockText = completeLookBtn?.nextElementSibling;

        // VALUES
        const inventoryQty = Number(
          matchedVariant.inventory_quantity
        );

        const isPreorder =
          inventoryQty <= 0 &&
          matchedVariant.inventory_policy === "continue";

        const isLowStock =
          matchedVariant.available &&
          inventoryQty > 0 &&
          inventoryQty < 5;

        // BUTTON TEXT
        if (changeTitle) {
          changeTitle.innerText = isPreorder
            ? completeLookBtn.getAttribute("btn-title")
            : "Add to cart";
        }

        // LOW STOCK TEXT
        if (stockText) {
          stockText.innerText = isLowStock
            ? `LOW STOCK - only ${inventoryQty} remaining`
            : "";
        }

        return matchedVariant;
      } catch (error) {
        console.error("Invalid data-json:", error);
        return null;
      }
    }

    // OPEN POPUP
    openBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      const freeProducts = e.target.closest('.free-products');
      
     
      if (freeProducts){
        document.querySelector('.gift-floating-btn').click();
        return;
      } 

      document.body.classList.add("atc-opened");

      const variantId = openBtn.dataset.variantId;
      const isProperties = openBtn.dataset.properties ?? false;
      // SIMPLE PRODUCT
      if (variantId) {
        addToCart(variantId, 1, isProperties);
        return;
      }

      // CLOSE OTHER POPUPS
      document.querySelectorAll(".variant-popup").forEach((item) => {
        item.classList.remove("active");
      });

      // OPEN CURRENT POPUP
      popup?.classList.add("active");
      if (openBtn.closest(".mobile-look-products")) {
        document.body.classList.add("cstm-pro-overlay");
      }
    });

    // CLOSE POPUP
    closeBtn?.addEventListener("click", () => {
      popup?.classList.remove("active");
      document.body.classList.remove("cstm-pro-overlay");
      document.body.classList.remove("atc-opened");
    });

    // PREVENT CLOSE
    popupInner?.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    // VARIANT BUTTON CLICK
    variantButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const parent = btn.closest(".main-variant");

        // REMOVE ACTIVE
        parent?.querySelectorAll(".custom-size-row").forEach((item) => {
          item.classList.remove("active");
        });

        // ADD ACTIVE
        btn.classList.add("active");

        // GET VARIANT
        const jsonData =
          completeLookBtn?.dataset.json ||
          wrapper.querySelector("[data-json]")?.dataset.json;

        const selectedOptions = getSelectedOptions();

        const matchedVariant = getVariantDataFromJson(
          jsonData,
          selectedOptions
        );
        
        // COMPLETE LOOK PRODUCT
        if (popup?.querySelector(".cmpt-lk")) {
          return;
        }

        // SIMPLE VARIANT PRODUCT
        const variantId = btn.dataset.variantId;

        if (variantId) {
          addToCart(variantId, 1);
        }

        popup?.classList.remove("active");
      });
    });

    // COMPLETE LOOK BUTTON
    completeLookBtn?.addEventListener("click", (e) => {
      e.stopPropagation();

      const selectedOptions = getSelectedOptions();

      const jsonData = completeLookBtn.dataset.json;

      const matchedVariant = getVariantDataFromJson(
        jsonData,
        selectedOptions
      );

      if (matchedVariant?.id) {
        addToCart(matchedVariant.id, 1);

        popup?.classList.remove("active");
      } else {
        console.warn("Matching variant not found");
      }
    });
  });
}

window.initProductCustom = initProductCustom;

// INIT
document.addEventListener("DOMContentLoaded", () => {
  window.initProductCustom();

  // INFINITE SCROLL SUPPORT
  const productObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches(".atc-icon-wrapper") ||
          node.querySelector(".atc-icon-wrapper")
        ) {
          window.initProductCustom(node);
        }
      });
    });
  });

  productObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // CLOSE ALL POPUPS
  window.addEventListener("click", (e) => {
    if (
      e.target.closest("popup-component") ||
      e.target.closest(".popup__size") ||
      e.target.closest(".popup_ajax_size")
    ) {
      return;
    }
    document.querySelectorAll(".variant-popup").forEach((popup) => {
      popup.classList.remove("active");
        document.body.classList.remove("cstm-pro-overlay");
    });

    document.body.classList.remove("atc-opened");
  });
});


window.initPopupSlider = function(parent = document) {

  parent.querySelectorAll('.pop_image_container__innerr')
  .forEach((container) => {

    /*
    |--------------------------------------------------------------------------
    | PREVENT DOUBLE INIT
    |--------------------------------------------------------------------------
    */

    if (container.dataset.sliderInitialized === "true") {
      return;
    }

    container.dataset.sliderInitialized = "true";

    /*
    |--------------------------------------------------------------------------
    | YOUR CURRENT SLIDER CODE
    |--------------------------------------------------------------------------
    */

    const track = container.querySelector('.slider-track');

    let slides = container.querySelectorAll('.slide');

    const sizeWrapper =
      container.closest('.pop__contnet__inner')
      ?.querySelector('.sizes__wrapper');

    if (!track || !slides.length || !sizeWrapper) return;

    const sizeItems =
      sizeWrapper.querySelectorAll('.opener__handler');

    const originalCount = slides.length;

    /*
    |--------------------------------------------------------------------------
    | CLONES
    |--------------------------------------------------------------------------
    */

    const firstClone = slides[0].cloneNode(true);

    const lastClone =
      slides[originalCount - 1].cloneNode(true);

    track.appendChild(firstClone);

    track.insertBefore(lastClone, slides[0]);

    slides = container.querySelectorAll('.slide');

    let currentIndex = 1;

    let isAnimating = false;

    track.style.transition = 'none';

    track.style.transform =
      `translateX(-${currentIndex * 100}%)`;

    function getRealIndex(index) {

      if (index === 0) return originalCount - 1;

      if (index === originalCount + 1) return 0;

      return index - 1;

    }

    function updateActive(index) {

      const realIndex = getRealIndex(index);

      sizeItems.forEach(item =>
        item.classList.remove('activated')
      );

      if (sizeItems[realIndex]) {

        sizeItems[realIndex]
        .classList.add('activated');

      }

    }

    function moveTo(index) {

      if (isAnimating) return;

      isAnimating = true;

      currentIndex = index;

      track.style.transition =
        'transform 0.4s ease';

      track.style.transform =
        `translateX(-${currentIndex * 100}%)`;

      updateActive(currentIndex);

    }

    /*
    |--------------------------------------------------------------------------
    | BUTTONS
    |--------------------------------------------------------------------------
    */

    container.addEventListener('click', function (e) {

      if (e.target.closest('.next-btn')) {
        moveTo(currentIndex + 1);
      }

      if (e.target.closest('.pre-btn')) {
        moveTo(currentIndex - 1);
      }

    });

    /*
    |--------------------------------------------------------------------------
    | TRANSITION END
    |--------------------------------------------------------------------------
    */

    track.addEventListener('transitionend', (e) => {

      if (e.target !== track) return;

      if (currentIndex === originalCount + 1) {

        track.style.transition = 'none';

        currentIndex = 1;

        track.style.transform = `translateX(-100%)`;

      }

      if (currentIndex === 0) {

        track.style.transition = 'none';

        currentIndex = originalCount;

        track.style.transform =
          `translateX(-${originalCount * 100}%)`;

      }

      updateActive(currentIndex);

      isAnimating = false;

    });

    /*
    |--------------------------------------------------------------------------
    | TOUCH
    |--------------------------------------------------------------------------
    */

    let startX = 0;

    track.addEventListener('touchstart', (e) => {

      startX = e.touches[0].clientX;

    });

    track.addEventListener('touchend', (e) => {

      if (isAnimating) return;

      const endX = e.changedTouches[0].clientX;

      const diff = startX - endX;

      if (diff > 50) {

        moveTo(currentIndex + 1);

      } else if (diff < -50) {
        moveTo(currentIndex - 1);
      }

    });
    /*
    |--------------------------------------------------------------------------
    | SIZE BUTTONS
    |--------------------------------------------------------------------------
    */
    sizeItems.forEach((item, i) => {
      item.addEventListener('click', () => {
        isAnimating = false;
        moveTo(i + 1);
      });
    });
    updateActive(currentIndex);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // if (document.body.classList.contains('template_handle_quick_add')) {
  //   initPopupSlider();
  // }
  const mobileLookProducts = document.querySelector('.mobile-look-products');
  const elementsToWatch = document.querySelectorAll( '.recently-viewed_container, .media-gallery__grid');
  if (mobileLookProducts && elementsToWatch.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            mobileLookProducts.classList.remove('active');
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    elementsToWatch.forEach((el) => observer.observe(el));
  }
});